function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: 0.12,
  y1: -0.933,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#1bd1f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1597ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "n",
  x1: -0.007,
  y1: 0.296,
  x2: 1.111,
  y2: 0.73,
  xlinkHref: "#l"
}), /*#__PURE__*/React.createElement("filter", {
  id: "m",
  x: 0,
  y: 0,
  width: 89.466,
  height: 92.112,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1482.419 -1369.187)"
}, /*#__PURE__*/React.createElement("rect", {
  "data-name": "Rectangle 73",
  width: 30,
  height: 6,
  rx: 2,
  transform: "translate(1498 1458)",
  fill: "#56d2f7"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1482.42 1369.19)",
  filter: "url(#m)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "key",
  d: "M67.835 79.95l-1.414-1.414a2 2 0 010-2.829l3-3-2.758-2.757-3 3a2 2 0 01-2.829 0l-.707-.707a2 2 0 010-2.829l3-3-19.705-19.705a22.653 22.653 0 01-4.332 2.555A23.427 23.427 0 018.562 38.152a21.92 21.92 0 0110.81-29.7A23.426 23.426 0 0149.9 19.564a21.954 21.954 0 01-1.628 22.094L77.2 70.586a2 2 0 010 2.829L75.613 75l-4.95 4.95a2 2 0 01-2.829 0zM14.186 23.382A15.816 15.816 0 0023.9 43.5a15.816 15.816 0 0020.373-9.161 15.816 15.816 0 00-9.718-20.113 16.336 16.336 0 00-5.593-.992 15.625 15.625 0 00-14.776 10.148z",
  transform: "translate(2.68 -.42)",
  fill: "url(#n)"
})));

var SvgAccessible = function SvgAccessible(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-accessible",
    viewBox: "0 0 89.466 94.813",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAccessible, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accessible.1191c4dd.svg";
export { ForwardRef as ReactComponent };